import { render } from "./change-password.vue?vue&type=template&id=5d9a7f12"
import script from "./change-password.vue?vue&type=script&lang=js"
export * from "./change-password.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__